import { render, staticRenderFns } from "./ContentManagerPage.vue?vue&type=template&id=447f3490&scoped=true"
import script from "./ContentManagerPage.vue?vue&type=script&lang=js"
export * from "./ContentManagerPage.vue?vue&type=script&lang=js"
import style0 from "./ContentManagerPage.vue?vue&type=style&index=0&id=447f3490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f3490",
  null
  
)

export default component.exports